export default __webpack_public_path__ + "static/media/Cherry Seeds.5875f50f.PNG";